//Third party lib
import { useTranslation } from "react-i18next";
//Images
import good from "../../assets/images/feedback/good.svg";
import average from "../../assets/images/feedback/average.svg";
import veryGood from "../../assets/images/feedback/very-good.svg";
import excellent from "../../assets/images/feedback/excellent.svg";
import notSatified from "../../assets/images/feedback/not-satisfied.svg";

export default function FeedbackLegent() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        gap: "10px",
        flexWrap: "wrap",
      }}
      className="full center-end"
    >
      <div className="center-start">
        <img src={notSatified} alt="notSatified" />
        <span className="font-12 blue margin-left-5">{t("notSatisfied")}</span>
      </div>
      <div className="center-start">
        <img src={average} alt="average" />
        <span className="font-12 blue margin-left-5">{t("average")}</span>
      </div>
      <div className="center-start">
        <img src={good} alt="good" />
        <span className="font-12 blue margin-left-5">{t("good")}</span>
      </div>
      <div className="center-start">
        <img src={veryGood} alt="veryGood" />
        <span className="font-12 blue margin-left-5">{t("veryGood")}</span>
      </div>
      <div className="center-start">
        <img src={excellent} alt="excellent" />
        <span className="font-12 blue margin-left-5">{t("excellent")}</span>
      </div>
    </div>
  );
}
